import React, { useState } from 'react';

// import { FilterIcon } from '../../../icons'

import {
    Box,
    Drawer,
    Button,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme,
    InputLabel,

} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FilterwIcon } from '../../../../icons';

const DataFilterInsight = () => {

    const [selectStatus, SetSelectedStatus] = useState('')
    const [age, setAge] = React.useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    // export default function FilterPopup() {
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const DrawerContent = (

        <Box sx={{ width: isMobile ? '100vw' : 360, height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fff', borderRadius: isMobile ? 0 : '0 0 0 0' }} role="presentation">
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center"
                sx={{ p: '24px', borderBottom: '1px solid #D0D4E4', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                <Typography fontSize={'22px'} fontWeight={700} sx={{ fontFamily: 'Manrope' }}>Filter</Typography>
                <IconButton onClick={toggleDrawer(false)} sx={{ p: 0 }}>
                    <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                </IconButton>
                <Box onClick={toggleDrawer(false)}
                    style={{
                        position: 'absolute', backgroundColor: '#fff', borderRadius: '100px', boxShadow: '0px 1px 6px 2px #00000030', height: '32px',
                        width: '32px', display: 'flex', justifyContent: 'center', alignItems: 'center', left: '-12px', bottom: '-16px', cursor: 'pointer',
                        zIndex: 10,
                    }}>
                    <ChevronRightIcon fontSize="small" />
                </Box>
            </Box>
            {/* Body */}
            <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 3 }}>
                <Box sx={{ pb: 2, }}>
                    <FormControl fullWidth>
                        <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', marginBottom: '4px', fontFamily: 'Manrope', textAlign: 'left' }}>Classification</Typography>
                        <Select onChange={(e) => SetSelectedStatus(e.target.value)} value={selectStatus} displayEmpty sx={{ height: '40px' }}>
                            <MenuItem value={''}>Select an option</MenuItem>
                            <MenuItem value={40}>core work</MenuItem>
                            <MenuItem value={20}>Non - core work</MenuItem>
                            <MenuItem value={30}>Unproduction</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ pb: 2, }}>
                    <FormControl fullWidth>
                        <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', marginBottom: '4px', fontFamily: 'Manrope', textAlign: 'left' }}>Type of items</Typography>
                        <Select onChange={(e) => SetSelectedStatus(e.target.value)} value={selectStatus} displayEmpty sx={{ height: '40px' }}>
                            <MenuItem value={''}>Select an option</MenuItem>
                            <MenuItem value={40}>Apps & URLs</MenuItem>
                            <MenuItem value={20}>Apps</MenuItem>
                            <MenuItem value={30}>URLs</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            {/* Footer */}
            <Box
                sx={{
                    p: isMobile ? 2 : '24px 30px',
                    borderTop: '1px solid #DFDFDF',
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 2,
                    justifyContent: 'center',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1
                }}
            >
                <Button onClick={toggleDrawer(false)} variant="outlined" fullWidth={isMobile}
                    sx={{ backgroundColor: '#fff', textTransform: 'capitalize', color: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: 500, height: '50px', border: '1px solid #9095A1', borderRadius: '8px', fontFamily: 'Manrope' }}>
                    Clear Filters
                </Button>
            </Box>
        </Box>
    );

    return (
        <>
            {/* <Tooltip title="Filter" arrow placement='top'>
                <Button onClick={toggleDrawer(true)} sx={{
                    background: '#fff',
                    borderRadius: '50px',
                    color: '#1A1F36',
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    width: '40px',
                    height: '38px',
                    border: '1px solid #E5E8EB',
                    '&:hover': {
                        background: '#f5f5f5'
                    }
                }}><FilterIcon /></Button>
            </Tooltip> */}

            {/* <Button onClick={toggleDrawer(true)} sx={{
                gap: '10px', fontFamily: 'Manrope',
                background: '#fff',
                borderRadius: '50px',
                color: '#64748B',
                fontSize: '14px',
                textTransform: 'Uppercase',
                fontWeight: '500',
                height: '36px',
                border: 'none',
                padding: '8px 16px',
                border: '1px solid #E5E8EB',
                marginRight: '-14px',
                '&:hover': {
                    background: '#0076FE',
                    borderColor: '0076FE',
                    color: '#fff'
                }
            }}><FilterListIcon sx={{ fontSize: '18px',fontFamily:'Manrope' }} />Filter</Button> */}



            <Button onClick={toggleDrawer(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none', }}
                tabIndex={-1} startIcon={<FilterwIcon />}>
                Filter
            </Button>
            <div>
                <Drawer
                    anchor="right"
                    open={open}
                    onClose={toggleDrawer(false)}
                    PaperProps={{
                        sx: {
                            width: isMobile ? '100vw' : 360,
                            borderRadius: isMobile ? 0 : '0 0 0 0',
                            overflow: 'visible',
                        }
                    }}
                >
                    {DrawerContent}
                </Drawer>
            </div>

        </>



    );
}

export default DataFilterInsight;
